/**
 * Сроки жизни токенов и лимиты частоты (D35, D36).
 *
 * Числа живут здесь и нигде больше: ни в коде сервера, ни в переменных
 * окружения. Срок жизни токена — не настройка развёртывания.
 * Развёртывание, которое может выдать вечный access-токен, — это дыра,
 * включаемая переменной, и включат её однажды на стенде «чтобы
 * не разлогинивало».
 *
 * Всё в секундах: миллисекунды в сроке жизни читаются на три нуля
 * хуже, а `Date` всё равно принимает и то и другое.
 */
/**
 * Access-токен (D35). Отзыва у него нет — он проверяется подписью,
 * без обращения к базе, — поэтому 15 минут: это окно, в которое
 * действует уже погашенная сессия.
 */
export const ACCESS_TTL_SECONDS = 15 * 60;
/**
 * Refresh-токен (D35). Мастер заходит между сессиями партии, а это раз
 * в неделю-две; меньший срок означает пароль на каждом сеансе.
 */
export const REFRESH_TTL_SECONDS = 30 * 24 * 60 * 60;
/** Ссылка подтверждения почты: письмо читают не сразу, но и не через неделю. */
export const EMAIL_CONFIRMATION_TTL_SECONDS = 24 * 60 * 60;
/**
 * Ссылка сброса пароля: короче остальных намеренно. Она лежит
 * в почтовом ящике, а ящик тоже бывает чужим.
 */
export const PASSWORD_RESET_TTL_SECONDS = 60 * 60;
/**
 * Приглашение в кампанию (D38). Семь дней: зовут на игру, а не
 * в архив, и ссылка, пролежавшая неделю, скорее забыта, чем
 * не открыта. Мастер выпускает новую в любой момент.
 */
export const INVITE_TTL_SECONDS = 7 * 24 * 60 * 60;
/**
 * Эндпоинты, принимающие или выдающие токен (security-checklist.md,
 * п. 2). Список закрыт: ограничение частоты берётся отсюда по имени,
 * и процедура, которой здесь нет, просто не соберётся с этим типом.
 */
export const RATE_LIMITED_ENDPOINTS = [
    'register',
    'login',
    'refresh',
    'requestPasswordReset',
    'resetPassword',
    'confirmEmail',
    // Повторная отправка письма с подтверждением (D41). Ограничена
    // не ради перебора, а ради чужого ящика: без лимита кнопка
    // «отправить ещё раз» — это рассылка на любой адрес в один клик.
    'resendConfirmation',
    // Вход по ссылке-приглашению и заявка на смену устройства (D38).
    // Оба перебираемы: первый — токен приглашения, второй — код
    // персонажа, который короче намеренно (D29).
    'claimInvite',
    'requestDeviceChange',
];
/**
 * Лимиты по эндпоинтам (D36).
 *
 * Два последних стоят здесь не для полноты. Токен приходит из письма,
 * и без ограничения перебор одноразовых токенов ничем не отличается
 * от перебора пароля — с той разницей, что про пароль все помнят,
 * а про ссылку из письма забывают.
 *
 * Обновление токена ограничено заметно мягче: у мастера несколько
 * вкладок, и после сна ноутбука все они обновляются разом. Лимит
 * здесь — предохранитель от цикла, а не от перебора.
 */
export const RATE_LIMITS = {
    register: { limit: 5, windowSeconds: 60 * 60, scope: 'ip' },
    login: { limit: 10, windowSeconds: 15 * 60, scope: 'ip+email' },
    refresh: { limit: 60, windowSeconds: 15 * 60, scope: 'ip' },
    requestPasswordReset: { limit: 5, windowSeconds: 60 * 60, scope: 'ip+email' },
    resetPassword: { limit: 10, windowSeconds: 15 * 60, scope: 'ip' },
    confirmEmail: { limit: 10, windowSeconds: 15 * 60, scope: 'ip' },
    // Три письма в час на адрес: столько же, сколько разрешено самой
    // регистрации, и по той же причине — письмо стоит денег
    // у провайдера и доверия у почтовых служб.
    resendConfirmation: { limit: 3, windowSeconds: 60 * 60, scope: 'ip+email' },
    claimInvite: { limit: 10, windowSeconds: 15 * 60, scope: 'ip' },
    // Код персонажа — пятьдесят бит, но диктуется голосом, и потому
    // короче токенов. Пять попыток в час: свой код игрок вводит один
    // раз, а перебор чужого этим лимитом обессмысливается
    // (`packages/contracts/src/creation/code.ts`, расчёт длины).
    requestDeviceChange: { limit: 5, windowSeconds: 60 * 60, scope: 'ip' },
};
/**
 * Пути клиента, на которые ведут ссылки из писем.
 *
 * Живут в contracts, а не в маршрутах клиента, потому что ссылку
 * собирает сервер, а разбирает клиент — это в чистом виде граница
 * процесса (CLAUDE.md, п. 6). Путь, написанный строкой на сервере,
 * переживёт переименование маршрута ровно до первого переименования.
 */
export const AUTH_CONFIRM_PATH = '/auth/confirm';
export const AUTH_RESET_PATH = '/auth/reset';
/** Переход по приглашению в кампанию (D38): токен тоже фрагментом. */
export const INVITE_PATH = '/join';
/**
 * Ссылка из письма: origin клиента, путь и токен во фрагменте.
 *
 * Фрагмент, а не строка запроса, и это единственное решение здесь,
 * которое стоит объяснить. Фрагмент не уходит на сервер вообще:
 * ни в запросе статики, ни в логе объектного хранилища, ни в CDN,
 * ни в заголовке `Referer` при переходе по ссылке с открытой
 * страницы. Строка запроса попадает во все четыре места, а токен
 * из письма — это вход в аккаунт, и лежать ему в логе раздачи
 * статики незачем.
 *
 * Клиент читает его из `location.hash` и отправляет процедуре сам.
 */
export const AUTH_TOKEN_FRAGMENT_KEY = 'token';
function link(origin, path, token) {
    const base = origin.replace(/\/+$/, '');
    return `${base}${path}#${AUTH_TOKEN_FRAGMENT_KEY}=${encodeURIComponent(token)}`;
}
/**
 * Обратная операция: токен из фрагмента адреса. Живёт рядом
 * со сборкой ссылки намеренно — разъехаться им негде.
 */
export function tokenFromFragment(hash) {
    // Разбор вручную, а не `URLSearchParams`: contracts не зависит
    // ни от рантайма браузера, ни от рантайма Node (см. `WEB_ORIGIN`
    // в env.ts — там по той же причине регулярное выражение вместо
    // глобального `URL`).
    for (const part of hash.replace(/^#/, '').split('&')) {
        const eq = part.indexOf('=');
        if (eq < 0)
            continue;
        if (part.slice(0, eq) !== AUTH_TOKEN_FRAGMENT_KEY)
            continue;
        const token = decodeURIComponent(part.slice(eq + 1));
        return token === '' ? null : token;
    }
    return null;
}
export function confirmEmailLink(origin, token) {
    return link(origin, AUTH_CONFIRM_PATH, token);
}
export function passwordResetLink(origin, token) {
    return link(origin, AUTH_RESET_PATH, token);
}
/**
 * Ссылка-приглашение в кампанию (D8, D38).
 *
 * Собирается тем же способом и по той же причине, что и ссылки
 * из писем: токен во фрагменте не уходит ни в лог раздачи статики,
 * ни в `Referer`. Приглашение вдобавок пересылают в мессенджере,
 * и лишних копий у него быть не должно.
 */
export function inviteLink(origin, token) {
    return link(origin, INVITE_PATH, token);
}
//# sourceMappingURL=policy.js.map